<template>
  <div class="input-wrap" @paste="pasteHandler($event)">
    <input class="input-content" v-for="(item,index) in numbers"
           :class="numbers[index]&&'input_enter'"
           :ref="'input'+index"
           :key="index" v-model="numbers[index]"
           max="9" min="0" maxlength="1" type="number"
           @input="inputHandler($event,index)"
           @keydown.delete="deleteHandler($event,index)"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      numbers: ['', '', '', '', '', ''],
    }
  },
  watch: {
    numbers: {
      handler: function (val) {
        if (val.length === 6 && val.join('').length === 6) {
          this.$refs.input5[0].blur()
          this.$emit('inputComplete', val.join(''))
        }
      },
      deep: true
    }
  },
  methods: {
    deleteHandler(e, index) {
      if (e.key == 'Backspace') {
        this.numbers[index] = '';
        if (index != 0) {
          setTimeout(() => {
            e.target.parentNode.childNodes[index - 1].focus();
          }, 0);
        }
      }
    },
    inputHandler(e, index) {
      let inputValue;
      switch (e.inputType) {
        case 'insertText':
          inputValue = e.target.value;
          if (inputValue.length > 1) {
            e.target.value = inputValue.slice(-1);
          }
          this.numbers[index] = e.data;
          if (index < this.numbers.length - 1) {
            e.target.parentNode.childNodes[index + 1].focus();
          }
          break;
        case 'deleteContentBackward':
          this.numbers[index] = '';
          if (index !== 0) {
            e.target.parentNode.childNodes[index - 1].focus();
          }
          break;
        case 'insertFromPaste':
          if (e.target.value.length > 1) {
            e.target.value = e.target.value.slice(0, 1);
          }
          break;
        case 'deleteContentForward':
          this.numbers[index] = '';
          break;
      }
    },
    pasteHandler(e) {
      const clipdata = e.clipboardData || window.clipboardData;
      let value = clipdata.getData('text/plain');
      let len = value.length
      if (len == 6) {
        this.numbers = value.split('');
        if (e.target.tagName == 'INPUT') {
          const parent = e.target.parentElement;
          const inputs = parent.querySelectorAll('input');
          inputs[inputs.length - 1].focus();
        }
      } else {
        let parent = document.querySelector('.input-wrap')
        let focusInput = parent.querySelector('input.input-content:focus')
        let index = -1
        for (let child of parent.children) {
          index += 1
          if (child == focusInput) {
            break
          }
        }
        if (len > 6 - index) {
          value = value.slice(0, 6 - index)
          len = value.length
        }

        this.numbers.splice(index, len, ...value.split(''))
        const inputs = parent.querySelectorAll('input');
        inputs[index + len - 1].focus();
      }
    },
  },
  mounted() {
    // 等待dom渲染完成，在执行focus,否则无法获取到焦点
    this.$nextTick(() => {
      this.$refs.input0[0].focus()
    })
  },
}
</script>

<style lang="less" scoped>
.input-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.input-content {
  width: 34px;
  height: 52px;
  border: none;
  outline: none;
  text-align: center;
  background: transparent;
  border-bottom: 2px solid #EF9614;
  border-radius: 0;
  font-size: 30px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  color: #28435B;
}

.input-content:focus {
  border-bottom: 2px solid #EF9614;
}

.input_enter {
  border-bottom: 2px solid #EF9614;
}

.input-content:last-child {
  margin-right: 0;
}
</style>